import { AssetLocation } from '/@/modules/asset/enums/AssetLocation';

export const AssetLocationMetaMixin = (superClass) =>
  class extends superClass {
    /**
     * @var {string}
     */
    location;

    /**
     * @var {string}
     */
    locationDescription;

    initLocation(model = {}) {
      this.location = model.location;
      this.locationDescription = model.locationDescription;
    }

    /**
     * @returns {boolean}
     */
    get isOtherLocation() {
      return this.location === AssetLocation.OTHER.key;
    }
  };
